import React, { useCallback, useEffect } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import RingSpinner from '../../component/common/Spinner/RingSpinner';
import GamesContent from '../../component/Games/GamesContent';
import { gamesGetAction } from '../../redux/action/game';

const GamesContainer = () => {
  const [filterValue, setFilter] = useState(null);

  const [pageCount, setPageCount] = useState(0);
  const [pageSize1, setPageSize] = useState(1);
  const dispatch = useDispatch();
  const isUsersGetPending = useSelector(state => state.users.isUsersGetPending);
  const [searchParam] = useSearchParams();

  const { games } = useSelector(state => state.game);

  const fetchData = useCallback(
    ({ pageSize, pageIndex }) => {
      if (filterValue?.is_regex != undefined)
        dispatch(gamesGetAction(filterValue, pageIndex, pageSize));
      setPageSize(pageSize);
    },
    [filterValue]
  );

  useEffect(() => {
    if (games) setPageCount(Math.ceil(games?.total_items / pageSize1));
  }, [games, pageSize1]);

  useEffect(() => {
    const filter = Object.fromEntries([...searchParam]);
    if (filter.is_regex == null) filter.is_regex = true;
    setFilter(filter);
  }, [searchParam]);

  return (
    <>
      <GamesContent games={games} pageCount={pageCount} fetchData={fetchData} />
      <RingSpinner isLoading={isUsersGetPending} />
    </>
  );
};

export default GamesContainer;
